import '@/assets/styles/reset.scss';
import '@/assets/styles/iconfont.css';
import '@/assets/scss/elFit.scss';
import '@/r-fusion-pc/r-fusion-pc'; // 组件库
import '@/r-fusion-pc/com'; // 自定义/插件式 组件
import 'babel-polyfill';
import 'es6-promise/auto';
import '@/lib/wsgchallenge';
import './directives/index'; // 指令

import Vue from 'vue';
import router from '@/router';
import store from '@/store/index';
import i18n from '@/i18n/locale';
import config from '@/config/index';
import LodashFn from '@/utils/lodashFn';
import screenSizeType from '@/utils/screenSizeType';

// 加载所有VUE Plugins
require('@/plugins/index');
require('@/utils/fingerprint');

Vue.use(screenSizeType, {
  store,
});
Vue.use(LodashFn);

Vue.config.productionTip = false;
Vue.config.devtools = config.env.isDev;

export { Vue, i18n, router, store };
